
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { RecordPropsDefinition } from 'vue/types/options'
import { ThemeStruct } from '@/styles/theme_generator'
import 'reflect-metadata'

import {mapMutations} from 'vuex'

type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>;
};

// These must be kebab-case because they will be HTML attributes
// They will automatically be converted to camelCase by Vue behind the scenes (see below)
export const webComponentThemeProps: RecordPropsDefinition<Record<string, unknown>> = {
  'theme-color-primary'                 : {type: String},
  'theme-color-primary-font-contrast'   : {type: String},
  'theme-color-secondary'               : {type: String},
  'theme-color-secondary-font-contrast' : {type: String},
  'theme-color-button'                  : {type: String},
  'theme-color-button-font-contrast'    : {type: String},
  'theme-dimension-button-border-radius': {type: String},
  'theme-typography-primary-font'       : {type: String},
  'theme-typography-primary-font-URL'   : {type: String},
  'theme-typography-secondary-font'     : {type: String},
  'theme-typography-secondary-font-URL' : {type: String},
  'theme-typography-button-font'        : {type: String},
  'theme-typography-button-font-URL'    : {type: String},
  'theme-typography-button-weight'      : {type: String},
  'theme-typography-paragraph-font'     : {type: String},
  'theme-typography-paragraph-font-URL' : {type: String}
}

@Component<WebComponentThemeMixin>({
  computed: {
    webComponentTheme(): DeepPartial<ThemeStruct> {
      return {
        typography: {
          primary_font       : this.trimWhitespace(this['themeTypographyPrimaryFont'      ]) || undefined,
          primary_font_URL   : this.trimWhitespace(this['themeTypographyPrimaryFontURL'   ]) || undefined,
          secondary_font     : this.trimWhitespace(this['themeTypographySecondaryFont'    ]) || undefined,
          secondary_font_URL : this.trimWhitespace(this['themeTypographySecondaryFontURL' ]) || undefined,
          button_font        : this.trimWhitespace(this['themeTypographyButtonFont'       ]) || undefined,
          button_font_URL    : this.trimWhitespace(this['themeTypographyButtonFontURL'    ]) || undefined,
          button_weight      : this.trimWhitespace(this['themeTypographyButtonWeight'     ]) || undefined,
          paragraph_font     : this.trimWhitespace(this['themeTypographyParagraphFont'    ]) || undefined,
          paragraph_font_URL : this.trimWhitespace(this['themeTypographyParagraphFontURL' ]) || undefined,
        },
        colors: {
          primary                : this.trimWhitespace(this['themeColorPrimary'              ]) || undefined,
          primary_font_contrast  : this.trimWhitespace(this['themeColorPrimaryFontContrast'  ]) || undefined,
          secondary              : this.trimWhitespace(this['themeColorSecondary'            ]) || undefined,
          secondary_font_contrast: this.trimWhitespace(this['themeColorSecondaryFontContrast']) || undefined,
          button                 : this.trimWhitespace(this['themeColorButton'               ]) || undefined,
          button_font_contrast   : this.trimWhitespace(this['themeColorButtonFontContrast'   ]) || undefined,
        },
        dimensions: {
          button_border_radius: this.trimWhitespace(this['themeDimensionButtonBorderRadius']) || undefined,
        }
      }
    }
  },
  watch: {
    webComponentTheme: {
      immediate: true,
      handler(newval: DeepPartial<ThemeStruct>) { this.setThemeSparse(newval)}
    }
  }
})
export class WebComponentThemeMixin extends Vue {

  @Prop() themeTypographyPrimaryFont     !: string
  @Prop() themeTypographyPrimaryFontURL  !: string
  @Prop() themeTypographySecondaryFont   !: string
  @Prop() themeTypographySecondaryFontURL!: string
  @Prop() themeTypographyButtonFont      !: string
  @Prop() themeTypographyButtonFontURL   !: string
  @Prop() themeTypographyButtonWeight    !: string
  @Prop() themeTypographyParagraphFont   !: string
  @Prop() themeTypographyParagraphFontURL!: string

  @Prop() themeColorPrimary              !: string
  @Prop() themeColorPrimaryFontContrast  !: string
  @Prop() themeColorSecondary            !: string
  @Prop() themeColorSecondaryFontContrast!: string
  @Prop() themeColorButton               !: string
  @Prop() themeColorButtonFontContrast   !: string

  @Prop() themeDimensionButtonBorderRadius!: string

  setThemeSparse = mapMutations('config', ['setThemeSparse'])['setThemeSparse']

  trimWhitespace(str: string | undefined): string | undefined {
    if(str)
      return str.replace(/^[\s]+/, '')
                .replace(/[\s]+$/, '')
    else return str
  }

}
